import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var TagFinder = function TagFinder(context) {
  var _this = this;

  _classCallCheck(this, TagFinder);

  _defineProperty(this, "search", function (params) {
    return _this.context.http.get("/msvc/v1/events/tags?searchTerm?=".concat(params, "&limit=100&offset=0"));
  });

  _defineProperty(this, "post", function (params) {
    return _this.context.http.post('/msvc/v1/events/tags', params);
  });

  this.context = context;
};

export default TagFinder;